export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "muban-sucai",
    name: "模板素材",
    description: "海量精美模板，一键套用，快速出图",
    icon: "ri-layout-grid-line",
  },
  {
    slug: "chuangyi-sheji",
    name: "创意设计",
    description: "灵感无限，打造独一无二的视觉作品",
    icon: "ri-paint-brush-line",
  },
  {
    slug: "tuwen-zhizuo",
    name: "图文制作",
    description: "轻松编辑图文内容，排版从未如此简单",
    icon: "ri-image-edit-line",
  },
  {
    slug: "shiyong-jiaocheng",
    name: "使用教程",
    description: "从入门到精通，手把手教你玩转黄油",
    icon: "ri-book-open-line",
  },
  {
    slug: "sheji-linggan",
    name: "设计灵感",
    description: "全球优秀设计作品，激发你的创作灵感",
    icon: "ri-lightbulb-line",
  },
  {
    slug: "sucaiku",
    name: "素材库",
    description: "海量高清图片、字体、插画素材任你选",
    icon: "ri-stack-line",
  },
];